export default __webpack_public_path__ + "static/media/glass.215541da.webp";